export default __webpack_public_path__ + "static/media/a023-startup4.28e8a0d2.png";